import React, {memo} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SectionHeader = ({title, className, icon, sectionHeaderCheckout}) => {
  const headerClass = classnames('section-header', className, {
    'section-header-checkout': sectionHeaderCheckout
  });

  return (
    <h3 className={headerClass}>
      {icon && <i className={`icon ${icon} mr-2`} />}
      <span>{title}</span>
    </h3>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  sectionHeaderCheckout: PropTypes.bool.isRequired
};

SectionHeader.defaultProps = {
  sectionHeaderCheckout: true
};

export default memo(SectionHeader);
